var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuropsyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 103,
    viewBox: "0 0 105 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8777 9.96782C50.8777 5.06193 46.9632 1.08416 42.1358 1.0013C37.3085 0.919246 33.3125 4.78947 33.21 9.73041C33.2012 10.1957 33.238 10.6498 33.2976 11.0975C31.9554 10.206 30.3679 9.65632 28.6498 9.60453C23.7813 9.44839 19.6995 13.3186 19.5313 18.3169C19.4962 19.4219 19.6671 20.4831 19.9956 21.4717C19.809 21.455 19.6224 21.4327 19.4314 21.4271C14.5068 21.2734 10.3461 25.2049 10.1341 30.2574C10.0596 32.1184 10.5424 33.8607 11.4343 35.3178C6.33617 35.658 2.13697 39.9178 1.87939 45.234C1.68402 49.3368 3.94088 52.8573 7.37261 54.4204C3.81385 56.0217 1.20742 59.5725 1.01204 63.6753C0.751838 69.0297 4.73814 72.222 10.0588 72.4434C8.95049 73.8528 8.25573 75.5536 8.17776 77.3693C7.96661 82.1174 12.0537 85.7709 17.3103 85.5877C17.5136 85.5805 17.7125 85.5582 17.9131 85.5399C17.4996 86.4728 17.2464 87.4718 17.2105 88.5107C17.0422 93.2086 21.2152 96.8144 26.5323 96.6383C28.4256 96.5778 30.1979 96.0424 31.7005 95.1812C32.4636 99.0442 36.3316 101.863 41.0538 101.788C46.4025 101.703 50.7392 97.964 50.7384 93.352C50.7857 66.4796 50.8312 38.5571 50.8777 9.96782Z",
    fill: "#E71E73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8777 9.96782C50.8777 5.06193 46.9632 1.08416 42.1358 1.0013C37.3085 0.919246 33.3125 4.78947 33.21 9.73041C33.2012 10.1957 33.238 10.6498 33.2976 11.0975C31.9554 10.206 30.3679 9.65632 28.6498 9.60453C23.7813 9.44839 19.6995 13.3186 19.5313 18.3169C19.4962 19.4219 19.6671 20.4831 19.9956 21.4717C19.809 21.455 19.6224 21.4327 19.4314 21.4271C14.5068 21.2734 10.3461 25.2049 10.1341 30.2574C10.0596 32.1184 10.5424 33.8607 11.4343 35.3178C6.33617 35.658 2.13697 39.9178 1.87939 45.234C1.68402 49.3368 3.94088 52.8573 7.37261 54.4204C3.81385 56.0217 1.20742 59.5725 1.01204 63.6753C0.751838 69.0297 4.73814 72.222 10.0588 72.4434C8.95049 73.8528 8.25573 75.5536 8.17776 77.3693C7.96661 82.1174 12.0537 85.7709 17.3103 85.5877C17.5136 85.5805 17.7125 85.5582 17.9131 85.5399C17.4996 86.4728 17.2464 87.4718 17.2105 88.5107C17.0422 93.2086 21.2152 96.8144 26.5323 96.6383C28.4256 96.5778 30.1979 96.0424 31.7005 95.1812C32.4636 99.0442 36.3316 101.863 41.0538 101.788C46.4025 101.703 50.7392 97.964 50.7384 93.352C50.7857 66.4796 50.8312 38.5571 50.8777 9.96782Z",
    stroke: "#E71E73",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9603 86.1259C30.7537 90.9561 30.4515 98.4879 36.3828 100.82",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5188 76.7332C29.2791 63.2002 50.5949 71.8759 41.2722 83.4611",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3614 4.13678C32.2617 7.69072 32.4282 15.6988 39.2154 18.9548",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.505 27.2176C37.37 27.2749 53.0174 45.5274 35.6021 59.1736",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5329 11.8497C17.5198 16.3381 18.3827 27.7488 30.0061 31.0327",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0546 40.9088C17.0388 40.9231 18.8419 49.8546 31.2897 45.5151",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4626 46.7072C27.4407 46.7279 32.5002 56.4297 20.077 59.2722C20.0638 59.2818 27.9375 62.3338 23.8714 68.8323",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1829 68.9097C17.1916 68.9049 14.0578 73.6403 7.25653 72.0557",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7648 70.3956C37.0185 62.793 47.1516 63.5212 50.7787 70.265",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1911 54.3658C15.2034 54.345 4.6112 57.2051 2.37799 48.8743",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5764 36.6625C44.0097 31.3551 49.9778 33.1253 50.8364 35.4507",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5563 28.4157C24.5694 28.4038 20.0688 36.012 26.524 37.8507",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1216 9.96782C54.1216 5.06193 58.036 1.08416 62.8634 1.0013C67.6908 0.919246 71.6867 4.78947 71.7892 9.73041C71.798 10.1957 71.7612 10.6498 71.7016 11.0975C73.0447 10.206 74.6313 9.65632 76.3494 9.60453C81.2188 9.44839 85.2997 13.3186 85.468 18.3169C85.5039 19.4219 85.3322 20.4831 85.0036 21.4717C85.1911 21.455 85.3768 21.4327 85.5678 21.4271C90.4925 21.2734 94.6531 25.2049 94.8651 30.2574C94.9405 32.1184 94.4569 33.8607 93.565 35.3178C98.6631 35.658 102.862 39.9178 103.12 45.234C103.315 49.3368 101.058 52.8573 97.6275 54.4204C101.186 56.0217 103.792 59.5725 103.988 63.6753C104.247 69.0297 100.261 72.222 94.9413 72.4434C96.0496 73.8528 96.7435 75.5536 96.8215 77.3693C97.0335 82.1174 92.9456 85.7709 87.6889 85.5877C87.4856 85.5805 87.2868 85.5582 87.0861 85.5399C87.4997 86.4728 87.7529 87.4718 87.7888 88.5107C87.957 93.2094 83.785 96.8144 78.467 96.6383C76.5737 96.5778 74.8022 96.0424 73.2997 95.1812C72.5366 99.0442 68.6677 101.863 63.9454 101.788C58.5968 101.703 54.2609 97.964 54.2609 93.352C54.2144 66.4796 54.168 38.5571 54.1216 9.96782Z",
    fill: "#E71E73"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1216 9.96782C54.1216 5.06193 58.036 1.08416 62.8634 1.0013C67.6908 0.919246 71.6867 4.78947 71.7892 9.73041C71.798 10.1957 71.7612 10.6498 71.7016 11.0975C73.0447 10.206 74.6313 9.65632 76.3494 9.60453C81.2188 9.44839 85.2997 13.3186 85.468 18.3169C85.5039 19.4219 85.3322 20.4831 85.0036 21.4717C85.1911 21.455 85.3768 21.4327 85.5678 21.4271C90.4925 21.2734 94.6531 25.2049 94.8651 30.2574C94.9405 32.1184 94.4569 33.8607 93.565 35.3178C98.6631 35.658 102.862 39.9178 103.12 45.234C103.315 49.3368 101.058 52.8573 97.6275 54.4204C101.186 56.0217 103.792 59.5725 103.988 63.6753C104.247 69.0297 100.261 72.222 94.9413 72.4434C96.0496 73.8528 96.7435 75.5536 96.8215 77.3693C97.0335 82.1174 92.9456 85.7709 87.6889 85.5877C87.4856 85.5805 87.2868 85.5582 87.0861 85.5399C87.4997 86.4728 87.7529 87.4718 87.7888 88.5107C87.957 93.2094 83.785 96.8144 78.467 96.6383C76.5737 96.5778 74.8022 96.0424 73.2997 95.1812C72.5366 99.0442 68.6677 101.863 63.9454 101.788C58.5968 101.703 54.2609 97.964 54.2609 93.352C54.2144 66.4796 54.168 38.5571 54.1216 9.96782Z",
    stroke: "white",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0393 86.1259C74.2459 90.9561 74.5482 98.4879 68.6169 100.82",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4805 76.7332C75.7202 63.2002 54.4044 71.8759 63.7271 83.4611",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6383 4.13678C72.738 7.69072 72.5715 15.6988 65.7843 18.9548",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4942 27.2176C67.63 27.2749 51.9827 45.5274 69.3971 59.1736",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4669 11.8497C87.48 16.3381 86.617 27.7488 74.9928 31.0327",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9451 40.9088C87.96 40.9231 86.1578 49.8546 73.71 45.5151",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.537 46.7072C77.5589 46.7279 72.4994 56.4297 84.9218 59.2722C84.9358 59.2818 77.0622 62.3338 81.1282 68.8323",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8164 68.9097C87.8076 68.9049 90.9415 73.6403 97.7427 72.0557",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.235 70.3956C67.9813 62.793 57.8482 63.5212 54.2211 70.265",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8085 54.3658C89.7963 54.345 100.388 57.2051 102.621 48.8743",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4232 36.6625C60.9899 31.3551 55.0219 33.1253 54.1633 35.4507",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80.443 28.4157C80.4307 28.4038 84.9313 36.012 78.4752 37.8507",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.043 54.8792C78.043 67.9319 66.4065 78.5125 52.0532 78.5125C37.6999 78.5125 26.0634 67.9319 26.0634 54.8792C26.0634 41.8274 37.6999 31.246 52.0532 31.246C66.4065 31.246 78.043 41.8274 78.043 54.8792Z",
    fill: "#FCA19B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8923 36.7636C70.2573 37.8025 71.5241 38.9855 72.6648 40.3096C81.4846 50.5476 79.5002 65.4023 68.2422 73.4232C59.7238 79.4906 48.2993 79.9336 39.4225 75.3567",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6024 72.1462C33.615 71.3113 32.6855 70.396 31.8278 69.4001C23.0088 59.1621 24.9915 44.3082 36.2504 36.2873C44.4376 30.4557 55.3102 29.8192 64.0249 33.8432",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5448 65.7378C64.8632 66.4261 64.1071 67.0706 63.2783 67.661C55.5133 73.1914 44.2474 71.9462 38.1645 64.8862C33.7095 59.7142 33.2513 52.8349 36.3764 47.3507",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0493 43.8706C39.7046 43.2214 40.4265 42.6111 41.2141 42.0503C48.9782 36.519 60.2459 37.7634 66.3287 44.8235C70.7662 49.9747 71.2376 56.8221 68.1528 62.296",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3885 62.0439C45.6946 61.5771 45.0585 61.0194 44.5013 60.3717C41.1554 56.4879 41.908 50.8539 46.1782 47.8122C50.4492 44.7689 56.646 45.4541 59.9918 49.3378C63.3377 53.2216 62.5851 58.8564 58.3141 61.8981C55.7471 63.7273 52.4836 64.2101 49.5617 63.4588",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0547 71.0912L53.1966 78.1313",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9978 58.0115L35.493 60.5553",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2968 32.0185L54.4951 38.7273",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4393 84.2923C31.4251 87.3826 38.1624 86.3525 37.6858 80.908",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5355 84.2923C73.5497 87.3826 66.8124 86.3525 67.289 80.908",
    stroke: "#F7F7F8",
    strokeWidth: 1.88933,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuropsyIcon);
export default __webpack_public_path__ + "static/media/neuropsy-icon.694fd8d017058069d5979f3c89683a27.svg";
export { ForwardRef as ReactComponent };